import { useState } from "react";

// 02.7-settings.md §0.8/paso b -- extraído de WhatsPanel.jsx, que lo exportaba inline junto al
// default (`UserProfilePanel.jsx` lo importaba desde ahí, un archivo de 2000+ líneas para un
// componente de 12). Cero cambio de comportamiento.
export const ChatAvatar = ({ url, name, jid, isGroup }) => {
  const [error, setError] = useState(false);
  const borderRadius = isGroup ? "8px" : "50%";
  if (!url || error) {
    return (
      <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#e2e8f0", borderRadius, color: "#64748b", fontWeight: "bold" }}>
        {String(name || jid || "").charAt(0).toUpperCase()}
      </div>
    );
  }
  return <img src={url} alt="avatar" onError={() => setError(true)} style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius }} />;
};
